import { render } from "./EditOwner.vue?vue&type=template&id=bd639d6e"
import script from "./EditOwner.vue?vue&type=script&lang=js"
export * from "./EditOwner.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__